import {
  GET_PROVIDER_TYPE,
  GET_PROVIDER_TYPE_SUCCESS,
  GET_PROVIDER_TYPE_FAILURE,
} from 'store/registerProviderType/registerProviderTypeAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const registerProviderTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROVIDER_TYPE:
      return { ...state, loading: true };
    case GET_PROVIDER_TYPE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_PROVIDER_TYPE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default registerProviderTypeReducer;
